/* eslint-disable max-classes-per-file */
export class MessagingError extends Error {
  name = "Messaging Error";

  constructor(public message: string) {
    super();
  }
}

export class CallError extends Error {
  name = "Call Error";

  constructor(
    public message: string,
    public type: string,
  ) {
    super();
  }
}

/**
 * Detects whether a WebSocket/STOMP error message represents an authentication
 * rejection from the backend. Auth rejections must stop the reconnect loop and be
 * kept out of Sentry (they are expected, not system anomalies).
 *
 * Matches:
 *  - the backend interceptor's messages (all prefixed "WebSocket authentication failed, ...")
 *  - legacy Spring Security messages ("Access is denied" / "AccessDeniedException")
 */
export const isAuthRejection = (message?: string | null): boolean => {
  if (!message) return false;

  return /access is denied|accessdeniedexception|authentication failed/i.test(
    message,
  );
};

const UNRECOVERABLE_SERVER_ERRORS = [
  /nested exception is java\.lang\.NullPointerException/i,
  /java\.lang\.nullpointerexception/i,
];

export const isUnrecoverableServerError = (
  message?: string | null,
): boolean => {
  if (!message) return false;

  return UNRECOVERABLE_SERVER_ERRORS.some((serverError) =>
    serverError.test(message),
  );
};
